<aside id="sidebar_right" class="nano affix sidebar_left_position" 
    ng-class="tab == 0 ? 'show-mobile-sidebar' : 'hide-mobile-sidebar'"
    style="left:260px;border-left: 1px solid #ddd;">
    <div class="sidebar-header">
        <strong>Filtrele </strong>
        <div class="pull-right">
            <a href="#" class="ml10" style="color:#fff" ng-click="filterPanelStatus()">
                <i class="fa fa-close"></i>
            </a>
        </div>
    </div>
    <div class="row" style="overflow: auto !important;height: calc(100% - 24px);">

        <div class="col-md-12">
            <div class="form-group">
                <label class="control-label">
                    Kargo No & Özel Alan : 
                </label>
                <input type="text" class="form-control" ng-model="filterData.id" placeholder="Kargo No & Özel Alan" >
            </div>
        </div>

        <div class="col-md-12" ng-if="data.app_work">
            <div class="form-group">
                <label class="control-label">
                    Kargo Tarihi : 
                </label>
                <input type="text" options="opts" date-range-picker ng-model="filterData.scheduled_time" class="form-control" placeholder="Kargo Tarihi" >
            </div>
        </div>

        <div class="col-md-12">
            <div class="form-group" >
                <label class="control-label">
                    Oluşturma Tarihi : 
                </label>
                <input type="text" options="opts" date-range-picker ng-model="filterData.created_at" class="form-control" placeholder="Oluşturma Tarihi" >
            </div>
        </div>
        

        <div class="col-md-12">
            <div class="form-group">
                <label class="control-label">
                    Personel : 
                </label>
                <ui-select ng-model="filterData.workers" title="Personel Seçiniz" multiple>
                    <ui-select-match placeholder="Personel Seçiniz...">{{ $item.full_name }}</ui-select-match>
                    <ui-select-choices repeat="item as item in (data.workers | filter: $select.search) track by $index">
                        <div class="row mr10 ml10">
                            <span ng-bind="item.full_name"></span>
                        </div>
                    </ui-select-choices>
                </ui-select>
            </div>
        </div>

        <div class="col-md-12">
            <div class="form-group">
                <label class="control-label">
                    KargoDurumu : 
                </label>
                <ui-select ng-model="filterData.workSteps" title="KargoDurumu Seçiniz" multiple>
                    <ui-select-match placeholder="KargoDurumu Seçiniz...">{{ $item.name }}</ui-select-match>
                    <ui-select-choices repeat="item as item in (data.steps | filter: $select.search) track by $index">
                        <div class="row mr10 ml10">
                            <span ng-bind="item.name"></span>
                        </div>
                    </ui-select-choices>
                </ui-select>
            </div>
        </div>

        <div class="col-md-12">
            <div class="form-group">
                <label class="control-label">
                    KargoTürü : 
                </label>
                <ui-select ng-model="filterData.workTypes" title="KargoDurumu Seçiniz" multiple>
                    <ui-select-match placeholder="KargoDurumu Seçiniz...">{{ $item.name }}</ui-select-match>
                    <ui-select-choices repeat="item as item in (data.types | filter: $select.search) track by $index">
                        <div class="row mr10 ml10">
                            <span ng-bind="item.name"></span>
                        </div>
                    </ui-select-choices>
                </ui-select>
            </div>
        </div>

        <div class="col-md-12">
            <div class="btn-group">
                <a href="" class="btn btn-warning" ng-click="init('clear')">Temizle</a>
                <a href="" class="btn btn-primary" ng-click="init()">Filtrele</a>
            </div>
        </div>

    </div>
</aside>
